module.exports = __webpack_public_path__ + "img/nf.de87d19a.svg";